import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/user-external-accounts/constants';
import { userExternalAccountsQueryKeys } from '@/modules/user-external-accounts/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type CreateExternalAccountBody = ApiRequestBody<
  typeof endpoints.userExternalAccounts,
  'post'
>;

export const useCreateUserExternalAccountMutation = () => {
  return useMutation({
    mutationFn: async (
      params: { userId: string } & CreateExternalAccountBody,
    ) => {
      const { userId, ...body } = params;

      const { data } = await fetchClient.POST(endpoints.userExternalAccounts, {
        params: { path: { userId } },
        body,
      });
      return data;
    },
    onSettled: (_result, _error, variables) => {
      if (variables?.userId) {
        invalidateQuery(userExternalAccountsQueryKeys.list(variables.userId))();
      }
    },
  });
};
